export function filterToQueryBuilder(...fields) {
  return (query) => {
    if (!query) {
      return {};
    }

    const isQueryWithDot = query.includes('.');
    const queryNumber = isQueryWithDot ? NaN : parseInt(query, 10);
    const idField = fields.find((filed) => filed === 'id');

    if (idField && !Number.isNaN(queryNumber)) {
      return [{ 'id||$eq': queryNumber }];
    }

    const queryFields = fields
      .filter((field) => field !== 'id')
      .map((field) => ({ [`${field}||$contL`]: query }));

    return queryFields;
  };
}

export function andFilterToQueryBuilder(...fields) {
  return (query) => {
    if (!query) {
      return {};
    }

    const isQueryWithDot = query.includes('.');
    const queryNumber = isQueryWithDot ? NaN : parseInt(query, 10);
    const idField = fields.find((filed) => filed === 'id');

    if (idField && !Number.isNaN(queryNumber)) {
      return { 'id||$eq': queryNumber };
    }

    const queryFields = fields
      .filter((field) => field !== 'id')
      .map((field) => ({ [`${field}||$contL`]: query }))
      .reduce((acc, curr) => {
        const key = Object.keys(curr)[0];

        acc[key] = curr[key];

        return acc;
      }, {});

    return queryFields;
  };
}

export function formatDate(date) {
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (month < 10) month = `0${month}`;
  if (day < 10) day = `0${day}`;

  return `${year}-${month}-${day}`;
}

export const idNameFilterToQuery = (q) => {
  if (!q) {
    return {};
  }

  if (!Number.isNaN(Number(q))) {
    return [{ 'id||$eq': q }];
  }

  return [{ 'name||$cont': q }];
};
